import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import CustomerOnboarding from './CustomerOnboarding'
import CustomerOnboardingGate from './components/CustomerOnboardingGate'
import CreateCensusTemplate from './pages/CreateCensusTemplate/CreateCensusTemplate'
import CustomerDetail from './pages/CustomerDetail/CustomerDetail'
import {
  CENSUS_ONBOARDING,
  CENSUS_TEMPLATE_CREATE,
  CENSUS_TEMPLATE_EDIT,
  CENSUS_TEMPLATE_VIEW,
  ELIGIBLE_RULES_CREATE,
  ELIGIBLE_RULES_EDIT,
  ELIGIBLE_RULES_VIEW,
} from './paths'
import CreateEligibleRules from './pages/CreateEligibleRules/CreateEligibleRules'

const CensusOnboardingRoute = {
  path: CENSUS_ONBOARDING,
  component: CustomerOnboardingGate,
  onEnter(_nextState, _replace, callback) {
    // Whole-module gate for Customer Onboarding (templates, eligible rules,
    // customer detail, etc). Kept separate from COMPANY_IGNORE_ALLOWED_ROLES
    // so widening access to the Company Ignore panel doesn't also widen
    // access to the rest of this route.
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: CustomerOnboarding,
  },
  childRoutes: [
    {
      path: `:id/${CENSUS_TEMPLATE_CREATE}`,
      component: CreateCensusTemplate,
    },
    {
      path: `:id/${CENSUS_TEMPLATE_EDIT}/:templateId`,
      component: CreateCensusTemplate,
    },
    {
      path: `:id/${CENSUS_TEMPLATE_VIEW}/:templateId`,
      component: CreateCensusTemplate,
    },
    {
      path: `:id/${ELIGIBLE_RULES_CREATE}`,
      component: CreateEligibleRules,
    },
    {
      path: `:id/${ELIGIBLE_RULES_EDIT}/:templateId`,
      component: CreateEligibleRules,
    },
    {
      path: `:id/${ELIGIBLE_RULES_VIEW}/:templateId`,
      component: CreateEligibleRules,
    },
    {
      path: ':id',
      component: CustomerDetail,
    },
  ],
}

export default CensusOnboardingRoute
